/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarBlurbs_user" | "PdpRespShippingReturns_user" | "PdpRespBuyerAssuranceBox_user" | "PdpRespSidebarContact_user" | "PdpRespHeroCarousel_user" | "PdpRespDealerDetails_user" | "PdpRespSidebarSellerInfo_user" | "PdpSharedPromoCode_user" | "PdpRespSwatchSelector_user" | "SharedRecentlyViewedItems_user" | "PdpRespAboutModule_user">;
    readonly " $refType": "PdpRespContainer_user";
};
export type PdpRespContainer_user$data = PdpRespContainer_user;
export type PdpRespContainer_user$key = {
    readonly " $data"?: PdpRespContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_user",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_user",
      "args": null
    }
  ]
};
(node as any).hash = 'f5f4fa0f9ea6b71652feb9d7fc91fcca';
export default node;
